<!-- <div class="form-title">
  <span class="subtitle">{{title}}</span>
  <container-element  [ngSwitch]="viewMode">
    <span *ngSwitchCase="'popover'">
      <div class="rollup-down">
        <nb-icon class="arrowhead" icon="close-outline" #closeIcon (click)="togglePopover()"></nb-icon>
      </div>
    </span>
    <span *ngSwitchCase="'collapsible'">
      <ng-container *ngIf="findOpen;else collapsed">
        <div class="rollup-down">
          <nb-icon class="arrowhead" icon="arrowhead-up-outline" #chevron (click)="toggleIcon()"></nb-icon>
        </div>
      </ng-container>
      <ng-template #collapsed>
        <div class="rollup-down">
          <nb-icon class="arrowhead" icon="arrowhead-down-outline" #chevron (click)="toggleIcon()"></nb-icon>
        </div>
      </ng-template>
    </span>
    <span *ngSwitchDefault>
      
    </span>
  </container-element>
  
  
</div> -->
<ng-container *ngIf="form" [nbSpinner]="loading">
    <form (ngSubmit)="onSubmit()" [formGroup]="form" class="container" #container>
      <ng-container *ngFor="let formField of hiddenFields">
        <ubs-ofbiz-form-field [formField]="formField" [form]="form"></ubs-ofbiz-form-field>
      </ng-container>
      <ng-container *ngIf="layout === 'MultiColumn';else singleColumnLayout">
        <div class="row">
          <div class="col-6 col-sm-6 col-md-6 col-lg-6" *ngFor="let formField of shownFields">
            <ubs-ofbiz-form-field [formField]="formField" [form]="form" (openFieldDialogEvent)="openFieldDialog($event)" (selectedFile)="handleUpload($event)"></ubs-ofbiz-form-field>
          </div> 
        </div>
      </ng-container>
      <ng-template #singleColumnLayout>
        <div class="form-row">
          <div *ngFor="let formField of shownFields">
            <ubs-ofbiz-form-field [formField]="formField" [form]="form" (openFieldDialogEvent)="openFieldDialog($event)" (selectedFile)="handleUpload($event)"></ubs-ofbiz-form-field>
          </div>
        </div>
      </ng-template>
        <div class="form-row submit">
          <button type="submit" nbButton status="primary" [disabled]="!form.valid" size="small">Submit</button>
        </div>
    </form>
    <ng-container *ngIf="isMultiPart">
      <div>
        <ubs-ofbiz-file-field-preview [fields]="hiddenFields" [selectedFile]="selectedFile" [form]="form"></ubs-ofbiz-file-field-preview>                        
      </div>
    </ng-container>
    
    <div *ngIf="payLoad" class="form-row">
      <strong>Saved the following values</strong><br>{{payLoad}}
    </div>
</ng-container>
<ng-container *ngIf="resultsOpen">
  <ng-container *ngIf="notFound;else searchResults">
    <div style="padding:0.875rem">Sorry, no records found for your query.</div>
  </ng-container>
  <ng-template #searchResults>
      <!-- <div class="form-title">
        <span class="subtitle">Search Results</span>
        <ng-container *ngIf="resultsOpen;else resultsCollapsed">
          <div class="rollup-down">
            <nb-icon class="arrowhead" icon="arrowhead-up-outline" #resultsChevron (click)="toggleIcon()"></nb-icon>
          </div>
        </ng-container>
        <ng-template #resultsCollapsed>
          <div class="rollup-down">
            <nb-icon class="arrowhead" icon="arrowhead-down-outline" #resultsChevron (click)="toggleIcon()"></nb-icon>
          </div>
        </ng-template>
      </div> -->
      <ubs-ofbiz-find-results [listForm]="listForm" [result]="result" [ofbizForm]="ofbizForm" [state]="state"></ubs-ofbiz-find-results>
  </ng-template>
</ng-container>






<!-- <div class="form-title">
  <span class="title">{{title}}</span>
  <ng-container *ngIf="open;else collaped">
      <nb-icon icon="chevron-up-outline" #chevron (click)="toggleIcon()"></nb-icon>
  </ng-container>
  <ng-template #collaped>
      <nb-icon icon="chevron-down-outline" #chevron (click)="toggleIcon()"></nb-icon>
  </ng-template>
</div>
  <ng-container *ngIf="form">
      <form (ngSubmit)="onSubmit()" [formGroup]="form" class="container" #container>
          <ng-container *ngFor="let formField of formFields">
            <ubs-ofbiz-form-field [formField]="formField" [form]="form"></ubs-ofbiz-form-field>
          </ng-container>
          <div class="form-row">
            <button type="submit" nbButton status="primary" [disabled]="!form.valid">Submit</button>
          </div>
      </form>
      <div *ngIf="payLoad" class="form-row">
        <strong>Saved the following values</strong><br>{{payLoad}}
      </div>
  </ng-container> -->
  